<template>
  <router-link v-if="to" :to="to">
    {{text}}
  </router-link>
  <a v-else-if="url" :href="url">
    {{text}}
  </a>
  <span v-else>{{text}}</span>
</template>

<script>
import { startCase } from 'lodash'

import { API_URL } from '@/services/constants.js'

export default {
  name: 'CartId',
  props: {
    noun: String,
    cart: Object,
  },
  computed: {
    text() {
      return `${startCase(this.noun)} ID: ${this.cart?.project?.id}`
    },
    to() {
      return this.$store.state.user.profile && this.$store.state.user.user?.DS2
        ? `/projects2/${this.cart?.project?.id}`
        : null
    },
    url() {
      return this.$store.state.user.profile && !this.to
        ? `${API_URL}projects/${this.cart?.project?.id}`
        : null
    },
  },
}
</script>
